import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

import { SnFormFieldConfig } from '@lib/form';
import { t } from '@lib/translation';

@Component({
  selector: 'sn-chat-media-message-description-dialog',
  templateUrl: './chat-media-message-description-dialog.component.html',
  styleUrls: ['./chat-media-message-description-dialog.component.scss'],
})
export class ChatMediaMessageDescriptionDialogComponent implements OnInit {
  public form = new FormGroup({});
  public formModel: any = {};
  public formFields: SnFormFieldConfig[] = [
    {
      key: 'description',
      type: 'textarea',
      templateOptions: {
        label: t('common.enterDescription'),
        autosize: true,
        autosizeMinRows: 5,
        appearance: 'outline',
        required: true,
      },
    },
  ];

  constructor(
    private readonly _dialogRef: MatDialogRef<ChatMediaMessageDescriptionDialogComponent>,
  ) {}

  public ngOnInit(): void {}

  public send(): void {
    this._dialogRef.close(this.formModel);
  }
}
